import { useTranslation } from "react-i18next";
import { LoadingState } from "shared/components/empty/LoadingState";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs, PageTabsStatus } from "shared/components/layout/PageTabs";
import { AppConfig } from "shared/config/AppConfig";
import { useHasPermission } from "shared/utils/PermissionUtils";

export const SettingsLayout: React.FC = () => {
  const { t } = useTranslation(["settings"]);

  const isService = useHasPermission("service");

  if (!AppConfig.subdomains?.isSubdomain) {
    return (
      <PageContainer>
        <PageContent isFullHeight={true}>
          <PageBody>
            <LoadingState />
          </PageBody>
        </PageContent>
      </PageContainer>
    );
  }

  const hiddenTabs: PageTabsStatus = {
    account: false,
    users: !isService,
  };
  const disabledTabs: PageTabsStatus = {
    account: false,
    users: !isService,
  };

  return (
    <PageContainer>
      <PageContent isFullHeight={true}>
        <PageHeader title={t("settings:title")} size="lg" />
        <PageBody>
          <PageTabs disabledTabs={disabledTabs} hiddenTabs={hiddenTabs} />
        </PageBody>
      </PageContent>
    </PageContainer>
  );
};
